import React from 'react';
import { 
  FaCcVisa, 
  FaCcMastercard, 
  FaCcAmex,
  FaCreditCard
} from 'react-icons/fa';
import { SiPix } from 'react-icons/si';

// Ícone personalizado do PIX (caso o SiPix não funcione bem)
const PixIcon = ({ className = "w-4 h-4" }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.45 9-11V7l-10-5z"/>
    <path d="M12 6L6 9v6c0 3.33 2.17 5.84 5 6.58 2.83-.74 5-3.25 5-6.58V9l-6-3z" fill="white"/>
    <text x="12" y="15" textAnchor="middle" fontSize="8" fill="currentColor" fontWeight="bold">PIX</text>
  </svg>
);

// Ícone do Elo
const EloIcon = ({ className = "w-4 h-4" }) => (
  <div className={`${className} bg-yellow-400 rounded text-white flex items-center justify-center text-xs font-bold`}>
    ELO
  </div>
);

// Ícone do Hipercard
const HipercardIcon = ({ className = "w-4 h-4" }) => (
  <div className={`${className} bg-red-500 rounded text-white flex items-center justify-center text-xs font-bold`}>
    H
  </div>
);

// Ícone do Diners
const DinersIcon = ({ className = "w-4 h-4" }) => (
  <div className={`${className} bg-blue-600 rounded text-white flex items-center justify-center text-xs font-bold`}>
    D
  </div>
);

// Componente principal que retorna o ícone apropriado
export const PaymentMethodIcon = ({ method, brand, className = "w-4 h-4" }) => {
  switch (method) {
    case 'pix':
      return <PixIcon className={className} />;
    
    case 'debit_card':
      return <FaCreditCard className={`${className} text-blue-600`} />;
    
    case 'credit_card':
      if (brand) {
        switch (brand.toLowerCase()) {
          case 'visa':
            return <FaCcVisa className={`${className} text-blue-700`} />;
          case 'mastercard':
            return <FaCcMastercard className={`${className} text-red-600`} />;
          case 'amex':
          case 'american express':
            return <FaCcAmex className={`${className} text-blue-500`} />;
          case 'elo':
            return <EloIcon className={className} />;
          case 'hipercard':
            return <HipercardIcon className={className} />;
          case 'dinners':
          case 'diners':
            return <DinersIcon className={className} />;
          default:
            return <FaCreditCard className={`${className} text-orange-600`} />;
        }
      }
      return <FaCreditCard className={`${className} text-orange-600`} />;
    
    default:
      return <FaCreditCard className={className} />;
  }
};

// Componente para exibir um método de pagamento com ícone e nome
export const PaymentMethodBadge = ({ method, brand, name, className = "" }) => {
  const getMethodName = (method, brand) => {
    if (method === 'pix') return 'PIX';
    if (method === 'debit_card') return 'Débito';
    if (method === 'credit_card') {
      if (brand) {
        const brandNames = {
          'visa': 'Visa',
          'mastercard': 'Mastercard',
          'amex': 'Amex',
          'elo': 'Elo',
          'hipercard': 'Hipercard',
          'dinners': 'Diners',
          'diners': 'Diners'
        };
        return brandNames[brand.toLowerCase()] || brand;
      }
      return 'Crédito';
    }
    return name || method;
  };

  const getBadgeColor = (method, brand) => {
    if (method === 'pix') return 'bg-green-100 text-green-800 border-green-300';
    if (method === 'debit_card') return 'bg-blue-100 text-blue-800 border-blue-300';
    if (method === 'credit_card') {
      if (brand) {
        switch (brand.toLowerCase()) {
          case 'visa':
            return 'bg-blue-50 text-blue-700 border-blue-200';
          case 'mastercard':
            return 'bg-red-50 text-red-700 border-red-200';
          case 'amex':
            return 'bg-blue-50 text-blue-600 border-blue-200';
          case 'elo':
            return 'bg-yellow-50 text-yellow-700 border-yellow-200';
          default:
            return 'bg-orange-50 text-orange-700 border-orange-200';
        }
      }
      return 'bg-orange-100 text-orange-800 border-orange-300';
    }
    return 'bg-gray-100 text-gray-800 border-gray-300';
  };

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-md border text-xs font-medium ${getBadgeColor(method, brand)} ${className}`}>
      <PaymentMethodIcon method={method} brand={brand} className="w-3 h-3" />
      {getMethodName(method, brand)}
    </span>
  );
};

export default PaymentMethodIcon;